import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import MedicareExplained from "./pages/MedicareExplained";
import Turning65 from "./pages/Turning65";
import AlreadyHaveMedicare from "./pages/AlreadyHaveMedicare";
import AnnualReview from "./pages/AnnualReview";
import ChronicNeeds from "./pages/ChronicNeeds";
import IndividualFamily from "./pages/IndividualFamily";
import Dental from "./pages/Dental";
import GroupInsurance from "./pages/GroupInsurance";
import LearnMore from "./pages/LearnMore";
import MedicareFraud from "./pages/MedicareFraud";
import AboutUs from "./pages/AboutUs";
import InformationalVideos from "./pages/InformationalVideos";
import { Toaster } from "./components/ui/toaster";

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App overflow-x-hidden">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/medicare-explained" element={<MedicareExplained />} />
              <Route path="/turning-65" element={<Turning65 />} />
              <Route path="/already-have-medicare" element={<AlreadyHaveMedicare />} />
              <Route path="/annual-review" element={<AnnualReview />} />
              <Route path="/chronic-needs" element={<ChronicNeeds />} />
              <Route path="/individual-family" element={<IndividualFamily />} />
              <Route path="/dental" element={<Dental />} />
              <Route path="/group-insurance" element={<GroupInsurance />} />
              <Route path="/learn-more" element={<LearnMore />} />
              <Route path="/medicare-calls" element={<MedicareFraud />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/informational-videos" element={<InformationalVideos />} />
            </Routes>
          </Layout>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
